// Action Types for get_vat_info and issue_tax_invoice APIs

export const GET_VAT_INFO_REQUEST = "GET_VAT_INFO_REQUEST";
export const GET_VAT_INFO_SUCCESS = "GET_VAT_INFO_SUCCESS";
export const GET_VAT_INFO_ERROR = "GET_VAT_INFO_ERROR";
export const GET_VAT_INFO_RESET = "GET_VAT_INFO_RESET";

export const ISSUE_TAX_INVOICE_REQUEST = "ISSUE_TAX_INVOICE_REQUEST";
export const ISSUE_TAX_INVOICE_SUCCESS = "ISSUE_TAX_INVOICE_SUCCESS";
export const ISSUE_TAX_INVOICE_ERROR = "ISSUE_TAX_INVOICE_ERROR";
export const ISSUE_TAX_INVOICE_RESET = "ISSUE_TAX_INVOICE_RESET";

export const CANCEL_TAX_INVOICE_REQUEST = "CANCEL_TAX_INVOICE_REQUEST";
export const CANCEL_TAX_INVOICE_SUCCESS = "CANCEL_TAX_INVOICE_SUCCESS";
export const CANCEL_TAX_INVOICE_ERROR = "CANCEL_TAX_INVOICE_ERROR";
export const CANCEL_TAX_INVOICE_RESET = "CANCEL_TAX_INVOICE_RESET";

export const UPDATE_TAX_INVOICE_REQUEST = "UPDATE_TAX_INVOICE_REQUEST";
export const UPDATE_TAX_INVOICE_SUCCESS = "UPDATE_TAX_INVOICE_SUCCESS";
export const UPDATE_TAX_INVOICE_ERROR = "UPDATE_TAX_INVOICE_ERROR";
export const UPDATE_TAX_INVOICE_RESET = "UPDATE_TAX_INVOICE_RESET";

export const GET_ACTIVE_TAX_INVOICES_REQUEST = "GET_ACTIVE_TAX_INVOICES_REQUEST";
export const GET_ACTIVE_TAX_INVOICES_SUCCESS = "GET_ACTIVE_TAX_INVOICES_SUCCESS";
export const GET_ACTIVE_TAX_INVOICES_ERROR = "GET_ACTIVE_TAX_INVOICES_ERROR";
export const GET_ACTIVE_TAX_INVOICES_RESET = "GET_ACTIVE_TAX_INVOICES_RESET";

export const VERIFY_CREDIT_NOTE_REQUEST = "VERIFY_CREDIT_NOTE_REQUEST";
export const VERIFY_CREDIT_NOTE_SUCCESS = "VERIFY_CREDIT_NOTE_SUCCESS";
export const VERIFY_CREDIT_NOTE_ERROR = "VERIFY_CREDIT_NOTE_ERROR";
export const VERIFY_CREDIT_NOTE_RESET = "VERIFY_CREDIT_NOTE_RESET";

// Request Types
export interface GetVatInfoRequest {
  payment_tran_ids?: number[];
  folio_item?: number | null;
}

export interface GetActiveTaxInvoicesRequest {
  invoice_no: string | null;
  customer: string | null;
  folio_id: number | null;
  start_date: string | null;
  end_date: string | null;
  paging: Record<string, any>;
  fromAdvanceButton?: boolean; // Flag to indicate request is from advance button menu
}

export interface VerifyCreditNoteRequest {
  payment_tran_ids?: number[];
  folio_item?: number | null;
  ref_vat_id: number;
}

// Type alias for interface property to avoid reserved keyword conflict
export interface InterfaceData {
  room_no: string | null;
  guest_ref: number | null;
  link_total: number;
  machine_no: string | null;
  calculate_vat: boolean;
  interface_from: string;
  document_reference: string | null;
  interface_from_text: string | null;
}

export interface CancelTaxInvoiceRequest {
  vat_id: number;
  remark: string;
}

export interface UpdateTaxInvoiceRequest {
  vat_id: number;
  header: {
    id: number | null;
    invoice_no: string | null;
    invoice_date: string;
    invoice_book_id: number | null;
    invoice_book_no: string;
    invoice_book_name: string | null;
    invoice_book_type: string | null;
    invoice_year: number;
    invoice_remark: string | null;
    include_vat: boolean;
    money_text_id: number;
    money_text_code: string | null;
    money_text_name: string | null;
  };
  customer: {
    cust_id: number | null;
    cust_name: string;
    cust_address: string;
    cust_tax_id: string | null;
    cust_phone: string | null;
    cust_mobile: string | null;
    cust_fax: string | null;
    e_mail: string | null;
    website: string | null;
    country_code: string;
    city: string;
    province: string;
    zip_code: string;
    buyer_type: string;
    buyer_type_name: string | null;
    cust_branch_no: number;
    cust_branch_type: string;
    cust_branch_type_text: string | null;
  };
  summary: {
    total: number;
    ar_amt: number;
    nonvat: number;
    vatable: number;
    zerovat: number;
    localvat: number;
    vat_rate: number | null;
    valueaddtax: number;
    service_rate: number | null;
    local_tax_rate: number;
  };
  payment_type: {
    paybank: boolean;
    paycard: boolean;
    paycash: boolean;
    payother: boolean;
    paybank_amt: number;
    paycard_amt: number;
    paycash_amt: number;
    paybank_desc: string;
    paycard_desc: string;
    paycash_desc: string;
    payother_amt: number;
    payother_desc: string;
  };
  interface: InterfaceData;
  detail: Array<{
    id: number | null;
    masid: number | null;
    revenue_desc: string;
    remark: string;
    qty: number;
    cost: number;
    amount: number;
    vattype: string;
    isroom: boolean;
  }>;
}

export interface IssueTaxInvoiceRequest {
  payment_tran_ids?: number[];
  folio_item?: number | null;
  isCreditNote?: boolean;
  invoice_data: {
    header: {
    id: number | null;
    invoice_no: string | null;
    invoice_date: string;
    invoice_book_id: number | null;
    invoice_book_no: string;
    invoice_book_name: string | null;
    invoice_book_type: string | null;
    invoice_year: number;
    invoice_remark: string | null;
    include_vat: boolean;
    money_text_id: number;
    money_text_code: string | null;
    money_text_name: string | null;
  };
  customer: {
    cust_id: number | null;
    cust_name: string;
    cust_address: string;
    cust_tax_id: string | null;
    cust_phone: string | null;
    cust_mobile: string | null;
    cust_fax: string | null;
    e_mail: string | null;
    website: string | null;
    country_code: string;
    city: string;
    province: string;
    zip_code: string;
    buyer_type: string;
    buyer_type_name: string | null;
    cust_branch_no: number;
    cust_branch_type: string;
    cust_branch_type_text: string | null;
  };
  summary: {
    total: number;
    ar_amt: number;
    nonvat: number;
    vatable: number;
    zerovat: number;
    localvat: number;
    vat_rate: number | null;
    valueaddtax: number;
    service_rate: number | null;
    local_tax_rate: number;
  };
  payment_type: {
    paybank: boolean;
    paycard: boolean;
    paycash: boolean;
    payother: boolean;
    paybank_amt: number;
    paycard_amt: number;
    paycash_amt: number;
    paybank_desc: string;
    paycard_desc: string;
    paycash_desc: string;
    payother_amt: number;
    payother_desc: string;
  };
  interface: InterfaceData;
  detail: Array<{
    id: number | null;
    masid: number | null;
    revenue_desc: string;
    remark: string;
    qty: number;
    cost: number;
    amount: number;
    vattype: string;
    isroom: boolean;
  }>;
  };
}

// Response Types
export interface InterfaceResponseData {
  room_no: string;
  guest_ref: number;
  link_total: number;
  machine_no: string | null;
  calculate_vat: boolean;
  interface_from: string;
  document_reference: string;
}

export interface GetVatInfoResponseData {
  result_code: string;
  result_msg: string;
  msg_code: string;
  result_data: {
    issue_type?: string;
    detail: Array<{
      qty: number;
      cost: number;
      amount: number;
      isroom: boolean;
      remark: string;
      vattype: string;
      revenue_desc: string;
    }>;
    header: {
      id: number | null;
      invoice_no: string | null;
      invoice_date: string;
      money_text_id: number;
      invoice_remark: string | null;
      invoice_book_no: string;
    };
    summary: {
      total: number;
      nonvat: number;
      vatable: number;
      zerovat: number;
      localvat: number;
      valueaddtax: number;
    };
    customer: {
      e_mail: string | null;
      cust_name: string;
      buyer_type: string;
      cust_phone: string | null;
      cust_mobile: string | null;
      cust_tax_id: string | null;
      country_code: string;
      cust_address: string;
      cust_branch_no: number | null;
      cust_branch_type: string;
    };
    "interface": InterfaceResponseData;
    payment_type: {
      paybank: boolean;
      paycard: boolean;
      paycash: boolean;
      payother: boolean;
      paybank_amt: number;
      paycard_amt: number;
      paycash_amt: number;
      paybank_desc: string;
      paycard_desc: string;
      paycash_desc: string;
      payother_amt: number;
      payother_desc: string;
    };
  };
}

export interface GetVatInfoResponse {
  data: GetVatInfoResponseData;
  status: number;
  message: string;
}

export interface IssueTaxInvoiceResponseData {
  result_code: string;
  result_msg: string;
  msg_code: string;
  result_data?: any;
}

export interface IssueTaxInvoiceResponse {
  data: IssueTaxInvoiceResponseData;
  status: number;
  message: string;
}

export interface CancelTaxInvoiceResponseData {
  result_code: string;
  result_msg: string;
  msg_code: string;
  result_data?: any;
}

export interface CancelTaxInvoiceResponse {
  data: CancelTaxInvoiceResponseData;
  status: number;
  message: string;
}

export interface UpdateTaxInvoiceResponseData {
  result_code: string;
  result_msg: string;
  msg_code: string;
  result_data?: any;
}

export interface UpdateTaxInvoiceResponse {
  data: UpdateTaxInvoiceResponseData;
  status: number;
  message: string;
}

export interface ActiveTaxInvoiceItem {
  id: number;
  invoice_no: string;
  invoice_date: string;
  customer: string;
  reference: string;
  vatable: number;
  non_vat: number;
  vat_amt: number;
  local_tax: number;
  balance: number;
}

export interface GetActiveTaxInvoicesResponseData {
  result_code: string;
  result_msg: string;
  msg_code: string;
  result_data: {
    items: ActiveTaxInvoiceItem[];
    paging: any;
  };
}

export interface GetActiveTaxInvoicesResponse {
  data: GetActiveTaxInvoicesResponseData;
  status: number;
  message: string;
}

// Action Interfaces
export interface GetVatInfoRequestAction {
  type: typeof GET_VAT_INFO_REQUEST;
  payload: GetVatInfoRequest;
}

export interface GetVatInfoSuccessAction {
  type: typeof GET_VAT_INFO_SUCCESS;
  payload: GetVatInfoResponse;
}

export interface GetVatInfoErrorAction {
  type: typeof GET_VAT_INFO_ERROR;
  payload: {
    message: string;
    error?: any;
  };
}

export interface GetVatInfoResetAction {
  type: typeof GET_VAT_INFO_RESET;
}

export interface IssueTaxInvoiceRequestAction {
  type: typeof ISSUE_TAX_INVOICE_REQUEST;
  payload: IssueTaxInvoiceRequest;
}

export interface IssueTaxInvoiceSuccessAction {
  type: typeof ISSUE_TAX_INVOICE_SUCCESS;
  payload: IssueTaxInvoiceResponse;
}

export interface IssueTaxInvoiceErrorAction {
  type: typeof ISSUE_TAX_INVOICE_ERROR;
  payload: {
    message: string;
    error?: any;
  };
}

export interface IssueTaxInvoiceResetAction {
  type: typeof ISSUE_TAX_INVOICE_RESET;
}

export interface CancelTaxInvoiceRequestAction {
  type: typeof CANCEL_TAX_INVOICE_REQUEST;
  payload: CancelTaxInvoiceRequest;
}

export interface CancelTaxInvoiceSuccessAction {
  type: typeof CANCEL_TAX_INVOICE_SUCCESS;
  payload: CancelTaxInvoiceResponse;
}

export interface CancelTaxInvoiceErrorAction {
  type: typeof CANCEL_TAX_INVOICE_ERROR;
  payload: {
    message: string;
    error?: any;
  };
}

export interface CancelTaxInvoiceResetAction {
  type: typeof CANCEL_TAX_INVOICE_RESET;
}

export interface UpdateTaxInvoiceRequestAction {
  type: typeof UPDATE_TAX_INVOICE_REQUEST;
  payload: UpdateTaxInvoiceRequest;
}

export interface UpdateTaxInvoiceSuccessAction {
  type: typeof UPDATE_TAX_INVOICE_SUCCESS;
  payload: UpdateTaxInvoiceResponse;
}

export interface UpdateTaxInvoiceErrorAction {
  type: typeof UPDATE_TAX_INVOICE_ERROR;
  payload: {
    message: string;
    error?: any;
  };
}

export interface UpdateTaxInvoiceResetAction {
  type: typeof UPDATE_TAX_INVOICE_RESET;
}

export interface GetActiveTaxInvoicesRequestAction {
  type: typeof GET_ACTIVE_TAX_INVOICES_REQUEST;
  payload: GetActiveTaxInvoicesRequest;
}

export interface GetActiveTaxInvoicesSuccessAction {
  type: typeof GET_ACTIVE_TAX_INVOICES_SUCCESS;
  payload: GetActiveTaxInvoicesResponse;
}

export interface GetActiveTaxInvoicesErrorAction {
  type: typeof GET_ACTIVE_TAX_INVOICES_ERROR;
  payload: {
    message: string;
    error?: any;
  };
}

export interface GetActiveTaxInvoicesResetAction {
  type: typeof GET_ACTIVE_TAX_INVOICES_RESET;
}

export interface VerifyCreditNoteRequestAction {
  type: typeof VERIFY_CREDIT_NOTE_REQUEST;
  payload: VerifyCreditNoteRequest;
}

export interface VerifyCreditNoteSuccessAction {
  type: typeof VERIFY_CREDIT_NOTE_SUCCESS;
  payload: GetVatInfoResponse;
}

export interface VerifyCreditNoteErrorAction {
  type: typeof VERIFY_CREDIT_NOTE_ERROR;
  payload: {
    message: string;
    error?: any;
  };
}

export interface VerifyCreditNoteResetAction {
  type: typeof VERIFY_CREDIT_NOTE_RESET;
}

export type VatInfoAction =
  | GetVatInfoRequestAction
  | GetVatInfoSuccessAction
  | GetVatInfoErrorAction
  | GetVatInfoResetAction
  | IssueTaxInvoiceRequestAction
  | IssueTaxInvoiceSuccessAction
  | IssueTaxInvoiceErrorAction
  | IssueTaxInvoiceResetAction
  | CancelTaxInvoiceRequestAction
  | CancelTaxInvoiceSuccessAction
  | CancelTaxInvoiceErrorAction
  | CancelTaxInvoiceResetAction
  | UpdateTaxInvoiceRequestAction
  | UpdateTaxInvoiceSuccessAction
  | UpdateTaxInvoiceErrorAction
  | UpdateTaxInvoiceResetAction
  | GetActiveTaxInvoicesRequestAction
  | GetActiveTaxInvoicesSuccessAction
  | GetActiveTaxInvoicesErrorAction
  | GetActiveTaxInvoicesResetAction
  | VerifyCreditNoteRequestAction
  | VerifyCreditNoteSuccessAction
  | VerifyCreditNoteErrorAction
  | VerifyCreditNoteResetAction;
